import { getPath } from '@/router/common'

const baseUrl = {
  title: '货物跟踪模板管理',
  path: 'GoodsTrackingTemplate'
}

export default [
  {
    path: getPath('GoodsTrackingTemplateMana', baseUrl),
    name: 'GoodsTrackingTemplateMana',
    component: () => import(/* webpackChunkName: "GoodsTrackingTemplateMana" */ '@/views/goodsTrackingTemplate/goodsTrackingTemplateMana/index.vue'),
    meta: {
      title: '货物跟踪模板管理'
    }
  },
  {
    path: getPath('CustomerInformationTemplateEdit', baseUrl),
    name: 'TrackingCustomerInformationTemplateEdit',
    component: () => import(/* webpackChunkName: "CustomerInformationTemplateEdit" */ '@/views/goodsTrackingTemplate/customerInformationTemplateEdit/index.vue'),
    meta: {
      title: '货物跟踪模板管理新增编辑'
    }
  }
]
